module.exports = __webpack_public_path__ + "img/g6.ad6e2b65.jpg";